import React from 'react';

export function ChevronDown () {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.6875 4.04626L6.22084 8.51252V8.51252C6.09905 8.63448 5.90145 8.63462 5.77948 8.51283C5.77938 8.51272 5.77927 8.51262 5.77917 8.51252L1.3125 4.04626"
        stroke="#071C3E"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>

  );
}
